import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Header } from "../../components/header/Index";
import SideBarMenu from "../../components/sideBarMenu/Index";
import Upcoming from "./upcoming/Index";
import Ongoing from "./ongoing/Index";
import Closed from "./closed/Index";
import { FetchUserData } from "../../common/functions/CommonFunctions";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { SocketUrl } from "../../config/constants/Constants";
import { postSocketApi } from "../../config/services/api/ApiServices";
import { setSocket, setSocketAuth } from "../../store/slices/socketSlice";
import { setLocation as setReduxLocation } from "../../store/slices/locationSlice";
import { io } from "socket.io-client";
import GetLocation from "../../components/getLocation/GetLocation";

const Bidding = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state: any) => state.user);
  const location = useAppSelector((state: any) => state.location);
  const isConnected = useAppSelector((state: any) => state.socket.isConnected);

  const [selectedTab, setSelectedTab] = useState("Upcoming");

  const [locationStatus, setLocationStatus] = useState<
    "loading" | "allowed" | "denied"
  >("loading");

  /* ================= USER ================= */

  useEffect(() => {
    FetchUserData(dispatch);
  }, [dispatch]);

  /* ================= LOCATION ================= */

  useEffect(() => {
    if (!navigator.geolocation) {
      setLocationStatus("denied");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        dispatch(
          setReduxLocation({
            latitude: pos.coords.latitude,
            longitude: pos.coords.longitude,
          }),
        );
        setLocationStatus("allowed");
      },
      () => setLocationStatus("denied"),
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      },
    );
  }, [dispatch]);

  const hasLocation = Boolean(location?.latitude && location?.longitude);

  /* ================= SOCKET ================= */

  const getSocketAuthorization = async () => {
    const path = "auth";
    const body = { user_id: user.userID };
    const res = await postSocketApi(path, body, {});
    if (res.status === 200) {
      localStorage.setItem("socketAuth", JSON.stringify(res.authorization));
      dispatch(setSocketAuth(res.authorization));
    }
  };

  async function initializeSocketIO() {
    const socket = io(SocketUrl, {
      transports: ["websocket", "polling"],
      reconnectionAttempts: 1,
    });

    dispatch(setSocket(socket));

    socket.emit("join", {
      name: user.userName,
      id: user.userID,
      TransporterID: user.transporterID,
    });

    await getSocketAuthorization();
    return socket;
  }

  useEffect(() => {
    let socketInstance: any;

    if (!isConnected && user?.userID) {
      initializeSocketIO().then((socket) => {
        socketInstance = socket;
      });
    }

    return () => {
      if (socketInstance) {
        socketInstance.off("join");
        socketInstance.disconnect();
      }
    };
  }, [isConnected, user?.userID]);

  /* ================= UI ================= */

  const topTabs: any = {
    Upcoming: <Upcoming />,
    Ongoing: <Ongoing />,
    Closed: <Closed />,
  };

  return (
    <Container fluid style={{ width: "100%", height: "100%" }}>
      <Header breadCrumb="Bidding" search={true} />

      <Row>
        <SideBarMenu selectedPath="Bidding" />

        <Col
          className="px-3 position-relative"
          style={{
            backgroundColor: "#f5f5f5",
            width: window.innerWidth - 110,
            minHeight: "100vh",
          }}
        >
          {/* Location overlay */}
          <GetLocation status={locationStatus} />

          {/* Main content */}
          {hasLocation && (
            <Row className="p-2">
              <Card className="border-0">
                <Card.Body>
                  <Row>
                    <Col className="d-flex p-0 m-0">
                      {Object.keys(topTabs).map((items: any) => (
                        <p
                          key={items}
                          className="me-2 px-3 py-1 text-center"
                          style={{
                            backgroundColor:
                              items === selectedTab ? "green" : "#ebebeb",
                            color: items === selectedTab ? "white" : "black",
                            cursor: "pointer",
                            borderRadius: 4,
                          }}
                          onClick={() => setSelectedTab(items)}
                        >
                          {items}
                        </p>
                      ))}
                    </Col>
                  </Row>

                  {topTabs[selectedTab]}
                </Card.Body>
              </Card>
            </Row>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default Bidding;
